import React, { useContext } from 'react';

import { SET_TABLE_SETTINGS, useScreenDispatch } from '@gogame/screens';

import ConceptFamiliesDataTableContext from 'scenes/Gallery/GalleryPage/ConceptFamilies/ConceptFamiliesDataTable/ConceptFamiliesDataTableContext';
import {
  COLUMN_ID,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
  COLUMN_UPDATED_DATE,
} from 'scenes/Gallery/GalleryPage/Concepts/ConceptsDataTable/constants';
import OrderControl from 'scenes/Gallery/components/OrderControl';
import { SCOPE_CONCEPT_FAMILIES } from 'scenes/Gallery/GalleryPage/constants';

const SORTED_COLUMNS_LIST = [
  { id: COLUMN_ID, name: 'ID' },
  { id: COLUMN_UPDATED_DATE, name: 'Last Updated' },
  { id: COLUMN_CREATED_BY, name: 'Created by' },
  { id: COLUMN_CREATED_DATE, name: 'Created' },
];

export default () => {
  const { tableSettings } = useContext(ConceptFamiliesDataTableContext);
  const dispatch = useScreenDispatch();

  const orderDirectionAsc = tableSettings.orderDir === 'asc';

  const handleChangeSettings = (id) => () => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      scope: SCOPE_CONCEPT_FAMILIES,
      payload: {
        ...tableSettings,
        orderBy: id,
        orderDir:
          tableSettings.orderBy !== id || orderDirectionAsc ? 'desc' : 'asc',
      },
    });
  };

  return (
    <OrderControl
      sortedColumnList={SORTED_COLUMNS_LIST}
      onChange={handleChangeSettings}
      orderDirectionAsc={orderDirectionAsc}
      orderBy={tableSettings.orderBy}
    />
  );
};
